import React, { useRef } from "react";
import { Container, ContentBox, Wrapper } from "./style";
import { useScrollFadeIn } from "hooks/useScrollFadeIn";
import { useTranslation } from "react-i18next";
import useBrToHTML from "hooks/useBrToHTML";
const Com4 = () => {
  const ref1 = useRef();
  const ref2 = useRef();
  const ref3 = useRef();
  useScrollFadeIn(ref1, ref2, ref3);
  const { t } = useTranslation("whatIsSketch");
  return (
    <Wrapper>
      <span>{t("4-1")}</span>
      <Container>
        <ContentBox ref={ref1} className="fade-in">
          <div>
            <img
              loading="lazy"
              src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/7b2f87c7WhatIsSketch_17.svg"
              alt=""
            />
          </div>
          <span>{t("4-2")}</span>
          <span>{useBrToHTML(t("4-3"))}</span>
        </ContentBox>
        <ContentBox ref={ref2} className="fade-in">
          <div>
            <img
              loading="lazy"
              src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/dcd5e27aWhatIsSketch_18.svg"
              alt=""
            />
          </div>
          <span>{t("4-4")}</span>
          <span>{useBrToHTML(t("4-5"))}</span>
        </ContentBox>
        <ContentBox ref={ref3} className="fade-in">
          <div>
            <img
              loading="lazy"
              src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/5cf96a15WhatIsSketch_19.svg"
              alt=""
            />
          </div>
          <span>{t("4-6")}</span>
          <span>{useBrToHTML(t("4-7"))}</span>
        </ContentBox>
      </Container>
    </Wrapper>
  );
};

export default Com4;
